import fetcher from '../utils/api';

const teamService = {
  getAllInvites: async () => fetcher('scribe_invite/', 'GET', true),
  inviteUser: async (teammateEmail, organizationId, message, permissionLevel, onboardingInvite, location) =>
    fetcher('scribe_invite/', 'POST', true, {
      email: teammateEmail,
      organization_id: organizationId,
      message,
      permission_level: permissionLevel,
      onboarding_invite: onboardingInvite,
      location
    }),
  referUser: async (email, message) =>
    fetcher('scribe_invite/refer/', 'POST', true, {
      email,
      message
    }),
  deleteInvites: async (ids) =>
    fetcher(`scribe_invite/delete_invites/`, 'POST', true, {
      invite_ids: ids
    }),
  changeUserPermission: async (userIds, organizationId, permissionLevel, fromProUpgrade) =>
    fetcher(`organizations/${organizationId}/user_permission`, 'POST', true, {
      user_ids: userIds,
      permission_level: permissionLevel,
      from_pro_upgrade: fromProUpgrade
    }),
  setActiveTeam: async (team) =>
    fetcher('users/active_org/', 'PUT', true, {
      org_id: team.id
    }),
  getTeamUsers: async (id, nameParam, sortParam, annotateCountInfo, annotateViewCountInfo, role, limit) => {
    const qParam = nameParam ? encodeURIComponent(nameParam.trim()) : '';
    const queryParams = [];

    if (qParam) {
      queryParams.push(`q=${qParam}`);
    }
    if (sortParam) {
      queryParams.push(`sort_by=${sortParam}`);
    }
    if (annotateCountInfo) {
      queryParams.push('annotate_count_info=1');
    }
    if (annotateViewCountInfo) {
      queryParams.push('annotate_view_count_info=1');
    }
    if (role) {
      queryParams.push(`role=${role}`);
    }
    if (limit) {
      queryParams.push(`limit=${limit}`);
    }
    const queryString = queryParams.length ? `?${queryParams.join('&')}` : '';

    return fetcher(`organizations/${id}/users/${queryString}`, 'GET', true);
  },
  getTeamCreators: async (id, includeDeactivatedUsers) => {
    const queryParams = [];

    if (includeDeactivatedUsers) {
      queryParams.push('include_deactivated=1');
    }
    const queryString = queryParams.length ? `?${queryParams.join('&')}` : '';

    return fetcher(`organizations/${id}/team_creators${queryString}`, 'GET', true);
  },
  getNextTeamUsers: async (url) => {
    return fetcher(url, 'GET', true);
  },
  getJoinableTeamUsers: async (id) => {
    return fetcher(`user_organizations/joinable/${id}/users/`, 'GET', true);
  },
  getTeamInvites: async (id, emailParam, sortParam) => {
    const queryParams = [];

    if (emailParam) {
      queryParams.push(`q=${emailParam}`);
    }
    if (sortParam) {
      queryParams.push(`sort_by=${sortParam}`);
    }
    const queryString = queryParams.length ? `?${queryParams.join('&')}` : '';

    return fetcher(`organizations/${id}/invites${queryString}`, 'GET', true);
  },
  createTeam: async (teamName, description, accessLevel) =>
    fetcher('organizations/', 'POST', true, {
      name: teamName,
      description,
      access_level: accessLevel
    }),
  editTeam: async (id, body) => {
    return fetcher(`organizations/${id}/`, 'PATCH', true, body);
  },
  deleteTeam: async (id) => fetcher(`organizations/${id}/`, 'DELETE', true),
  acceptInvite: async (inviteCode) =>
    fetcher(`scribe_invite/${inviteCode}/`, 'POST', true, {
      accept: 'true'
    }),
  rejectInvite: async (inviteCode) =>
    fetcher(`scribe_invite/${inviteCode}/`, 'POST', true, {
      accept: 'false'
    }),
  acknowledgeInvite: async (inviteCode) => fetcher(`scribe_invite/${inviteCode}/acknowledge/`, 'POST', true),
  leaveTeam: async (id) => fetcher(`organizations/${id}/leave/`, 'POST', true),
  updateSetting: async (teamId, setting, settingValue, isSuperOrganizationSetting) =>
    fetcher(`organizations/${teamId}/setting/`, 'POST', true, {
      setting,
      setting_value: settingValue,
      is_super_organization_setting: isSuperOrganizationSetting
    }),
  requestAccess: async (id) => fetcher(`organizations/${id}/requests/`, 'POST', true),
  // Types:
  // listAccessRequests: async (id: string) => fetcher(`organizations/${id}/requests/`, 'GET', true) as Promise<InvitedUser[]>,
  listAccessRequests: async (id) => fetcher(`organizations/${id}/requests/`, 'GET', true),
  // Types:
  // listSubOrgsAccessRequests: async (id: string) => fetcher(`organizations/${id}/requests/`, 'GET', true) as Promise<InvitedUser[]>,
  listSubOrgsAccessRequests: async (id) => fetcher(`super_organization/${id}/team_access_requests/`, 'GET', true),
  // Types:
  // acceptRequest: async (id: string, email: string, permissionLevel: PermissionLevel) =>
  acceptRequest: async (id, email, permissionLevel) =>
    fetcher(`organization_requests/${id}/`, 'POST', true, {
      email,
      accept_request: true,
      permission_level: permissionLevel
      // Types:
      // }) as unknown as Promise<void>,
    }),
  // Types:
  // rejectRequest: async (id: string, email: string) =>
  rejectRequest: async (id, email) =>
    fetcher(`organization_requests/${id}/`, 'POST', true, {
      email,
      accept_request: false
      // Types:
      // }) as unknown as Promise<void>,
    }),
  // Types:
  // bulkAcceptRequest: async (variables: { email: string; organization: string; permission_level: PermissionLevel }[]) =>
  bulkAcceptRequest: async (requests) =>
    fetcher(`organization_requests/`, 'POST', true, {
      accept_request: true,
      requests
      // Types:
      // }) as unknown as Promise<void>,
    }),
  // Types:
  // bulkRejectRequest: async (variables: { email: string; organization: string; permission_level: PermissionLevel }[]) =>
  bulkRejectRequest: async (requests) =>
    fetcher(`organization_requests/`, 'POST', true, {
      accept_request: false,
      requests
      // Types:
      // }) as unknown as Promise<void>,
    }),
  processInviteLinkSignup: async (invitingUserId, organizationId) =>
    fetcher('scribe_invite/accept_link/', 'POST', true, {
      inviting_user_id: invitingUserId,
      organization_id: organizationId
    }),
  resendInvite: async (inviteCode) => fetcher(`scribe_invite/${inviteCode}/resend_invite/`, 'POST', true),
  bulkResendInvites: async (inviteCodes) => fetcher(`scribe_invite/bulk_resend_invites/`, 'POST', true, { invite_ids: inviteCodes }),
  resendAllInvitesForTeam: async (teamId) => fetcher(`organization/${teamId}/resend_invites/`, 'POST', true),
  getAdditionalTeamInfo: async (teamId) => fetcher(`organizations/${teamId}/additional_info/`, 'GET', true),
  listOrganizationSettings: async (teamId) => fetcher(`organizations/${teamId}/setting/`, 'GET', true),
  getTeam: async (teamId) => fetcher(`organizations/${teamId}/`, 'GET', true),
  getInvitableUsers: async (teamId) => fetcher(`organizations/${teamId}/invitable_users/`, 'GET', true),
  getNextInvitableUsers: async (url) => fetcher(url, 'GET', true)
};

export default teamService;
